import React, { Suspense, lazy, useContext } from 'react';
import { Routes as DOMRoutes, Route, Navigate, Outlet } from 'react-router-dom';
import MainLayout from 'layout/MainLayout';
import AuthLayout from 'layout/AuthLayout';
import { Toaster } from 'components/ui/toaster';
import Loader from 'components/Loader';
import { useRefreshToken } from 'modules/auth/hooks/useRefreshToken';
import { AuthContext } from 'providers/auth';

const AuthPage = lazy(() => import('pages/Auth'));
const UsersCertificatesPage = lazy(() => import('pages/UsersCertificates/Page'));

function RequireAuth() {
  const { isAuthenticated } = useContext(AuthContext);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

function LoginRoute() {
  const { isAuthenticated } = useContext(AuthContext);
  if (isAuthenticated) {
    return <Navigate to="/user-certificate" replace />;
  }
  return (
    <AuthLayout>
      <AuthPage />
    </AuthLayout>
  );
}

function NotFoundRoute() {
  const { isAuthenticated } = useContext(AuthContext);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to="/user-certificate" replace />;
}

export const Routes = () => {
  const { isLoading } = useRefreshToken();
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <>
      <Suspense fallback={<Loader />}>
        {isLoading ? null : (
          <DOMRoutes>
            <Route path="/" element={<Navigate to="/user-certificate" replace />} />
            <Route path="/login" element={<LoginRoute />} />

            <Route element={<RequireAuth />}>
              <Route element={<MainLayout />}>
                <Route path="/user-certificate" element={<UsersCertificatesPage />} />
              </Route>
            </Route>

            <Route path="*" element={<NotFoundRoute />} />
          </DOMRoutes>
        )}
      </Suspense>
      <Toaster />
    </>
  );
};
